import { GoldCoins } from "../../assets/svg/Svgs";
import { DetailsView } from "../../components/details/DetailsView";
import { API_MY_INVESTMENTS } from "../../constants/apis";
import { INVESTMENTS, LOANS } from "../../constants/constants";
import {
  currencyFormat,
  formatDate,
  formatDateTime,
  stringify,
  unsetKeys,
} from "../../utils/helpers";
import { openBottomSheet } from "../../utils/modalUtils";

export const useInvestmentsList = () => {
  const title = "My Investments";

  const ListItem = ({ data }: { data: any }) => {
    const { loan, investments } = data || {};
    const { purpose } = loan || {};
    const { amount_invested, units_purchased, purchased_at } =
      investments?.[0] || {};
    return (
      <div
        className="flexNullCenter gap15"
        onClick={() => {
          openBottomSheet({
            component: "tabs",
            title: "investment Details",
            source: INVESTMENTS,
            data,
          });
        }}
      >
        <GoldCoins />

        {/* MID */}
        <div className="flexGrow">
          <div className="font13 semiBold textDark mb5 capitalize">
            {stringify(purpose)}
          </div>
          <div className="font12 grey">{units_purchased} Units Purchased</div>
          {/* <div className="flex">
            <div
            className="main font11 capitalize lightBg r5"
            style={{ padding: "3px 10px" }}
            >
            {status}
            </div>
            </div> */}
        </div>

        {/* END */}
        <div>
          <div className="font13 semiBold textDark mb5 textEnd">
            {currencyFormat(amount_invested)}
          </div>
          <div className="font12 grey">{formatDate(purchased_at)}</div>
        </div>
      </div>
    );
  };

  const viewData = (data: any) => {
    const { purchased_at } = data || {};
    return {
      ...unsetKeys(data, ["id"]),
      ...[
        "amount_invested",
        "interest_amount",
        "expected_repayment",
        "paid_amount",
      ].reduce((acc, key) => {
        return { ...acc, [key]: currencyFormat(data?.[key]) };
      }, {}),
      purchased_at: formatDateTime(purchased_at),
    };
  };

  const detailsTabs = ({ ...props }) => {
    const {
      data: { loan, investments },
    } = props || {};

    return [
      {
        key: "1",
        label: "investment",
        children: (
          <DetailsView
            data={investments?.[0]}
            source={INVESTMENTS}
            showTitle={false}
            enablePadding={false}
          />
        ),
      },
      {
        key: "2",
        label: "loan product",
        children: (
          <DetailsView
            source={LOANS}
            data={loan}
            showTitle={false}
            enablePadding={false}
          />
        ),
      },
    ];
  };

  return { title, ListItem, api: API_MY_INVESTMENTS, detailsTabs, viewData };
};
